document.addEventListener("DOMContentLoaded", function () {
  // === ELEMENTS ===
  const addToCartBtn = document.getElementById("add-to-cart-button");
  const btnFinalPrice = addToCartBtn?.querySelector(".btn-final-price");
  const btnNormalPrice = addToCartBtn?.querySelector(".btn-normal-price");

  const subscriptionSection = document.querySelector(".product__info-wrapper");
  const oneTimeSection = document.getElementById("one-time-section");

  const purchaseRadios = document.querySelectorAll('input[name="purchase_type"]');

  const hiddenVariantInput = document.getElementById("selected-variant-id");
  const hiddenQtyInput = document.getElementById("selected-qty");
  const hiddenPlanInput = document.getElementById("selected-selling-plan");

  // === HELPERS ===x
  // Hide the "normal" price if it's the same as the final price
  function toggleNormalPriceVisibility() {
    if (!btnFinalPrice || !btnNormalPrice) return;

    const toNum = (el) => {
      const t = (el.textContent || "").replace(/[^0-9.]/g, "");
      return t ? parseFloat(t) : NaN;
    };

    const finalVal = toNum(btnFinalPrice);
    const normalVal = toNum(btnNormalPrice);

    const same =
      !isNaN(finalVal) &&
      !isNaN(normalVal) &&
      Math.abs(finalVal - normalVal) < 0.005;

    btnNormalPrice.classList.toggle("hidden", same);
    btnNormalPrice.setAttribute("aria-hidden", same ? "true" : "false");
  }

  function updateButtonPrices() {
    const purchaseType = document.querySelector('input[name="purchase_type"]:checked')?.value;
    if (!purchaseType) return;

    let selectedRadio;
    if (purchaseType === "subscribe") {
      selectedRadio = subscriptionSection.querySelector('input[name="selling_plan"]:checked');
    } else {
      // be flexible: handle one_time_plan or one_time_plan_<id>
      selectedRadio =
        oneTimeSection.querySelector('input[name="one_time_plan"]:checked') ||
        oneTimeSection.querySelector('input[name^="one_time_plan"]:checked');
    }
    if (!selectedRadio) return;

    const wrapper = selectedRadio.closest(".radioChecSingle");
    if (!wrapper) return;

    const qty = wrapper.getAttribute("data-qty");
    const btnPrice =
      wrapper.getAttribute("data-btn-price") || wrapper.getAttribute("data-cut-btn-price");
    const normalPrice = wrapper.getAttribute("data-normal-btn-price");

    if (btnFinalPrice && btnPrice) btnFinalPrice.textContent = `$${parseFloat(btnPrice).toFixed(2)}`;
    if (btnNormalPrice && normalPrice) btnNormalPrice.textContent = `$${parseFloat(normalPrice).toFixed(2)}`;

    if (hiddenQtyInput && qty) hiddenQtyInput.value = qty;
    if (hiddenPlanInput) hiddenPlanInput.value = purchaseType === "subscribe" ? selectedRadio.value : "";

    // NEW: hide normal price if equal to final
    toggleNormalPriceVisibility();
  }

  function updateCheckedClass() {
    // clear all
    document.querySelectorAll('.radioChecSingle').forEach(w => w.classList.remove('checked'));

    const purchaseType = document.querySelector('input[name="purchase_type"]:checked')?.value;

    let selected;
    if (purchaseType === "subscribe") {
      selected = subscriptionSection?.querySelector('input[name="selling_plan"]:checked');
    } else {
      selected =
        oneTimeSection?.querySelector('input[name="one_time_plan"]:checked') ||
        oneTimeSection?.querySelector('input[name^="one_time_plan"]:checked');
    }

    selected?.closest('.radioChecSingle')?.classList.add('checked');
  }

  // select the first (or keep already-checked) plan
  function selectFirstPlan(purchaseType) {
    let radios;
    if (purchaseType === "subscribe") {
      radios = subscriptionSection.querySelectorAll('input[name="selling_plan"]');
    } else {
      radios =
        oneTimeSection.querySelectorAll('input[name="one_time_plan"]')?.length
          ? oneTimeSection.querySelectorAll('input[name="one_time_plan"]')
          : oneTimeSection.querySelectorAll('input[name^="one_time_plan"]');
    }
    if (!radios || radios.length === 0) return;

    const alreadyChecked = Array.from(radios).find(r => r.checked);
    (alreadyChecked || radios[0]).checked = true;

    updateCheckedClass();
    updateButtonPrices();
  }

  function addToCart(productData, button) {
    const spinner = button.querySelector(".loading__spinner");
    if (spinner) spinner.classList.remove("hidden");

    button.classList.add("disabled");
    button.setAttribute("disabled", "disabled");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: productData }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to add item to cart");
        return response.json();
      })
      .then(() => {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.open === "function") cartDrawer.open();
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Something went wrong. Please try again.");
      })
      .finally(() => {
        if (spinner) spinner.classList.add("hidden");
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
      });
  }

  // === HANDLE PURCHASE TYPE SWITCHING ===
  purchaseRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      const type = this.value;

      if (type === "subscribe") {
        subscriptionSection.style.display = "block";
        oneTimeSection.style.display = "none";
      } else {
        subscriptionSection.style.display = "none";
        oneTimeSection.style.display = "block";
      }

      selectFirstPlan(type);
    });
  });

  // === WATCH FOR PLAN SELECTION CHANGES ===
  document.addEventListener("change", function (e) {
    if (
      e.target.name === "purchase_type" ||
      e.target.name === "selling_plan" ||
      e.target.name === "one_time_plan" ||
      (e.target.name && e.target.name.startsWith("one_time_plan"))
    ) {
      updateButtonPrices();
      updateCheckedClass();
    }
  });

  // === INITIAL LOAD ===
  const defaultPurchaseRadio = document.querySelector('input[name="purchase_type"]:checked');
  if (defaultPurchaseRadio) {
    const type = defaultPurchaseRadio.value;

    if (type === "subscribe") {
      subscriptionSection.style.display = "block";
      oneTimeSection.style.display = "none";
    } else {
      subscriptionSection.style.display = "none";
      oneTimeSection.style.display = "block";
    }

    // Respect HTML's checked radio (from Liquid forloop.first), otherwise pick first
    selectFirstPlan(type);
  }

  // Optional: ensure correct visibility if initial values happen to be equal
  toggleNormalPriceVisibility();

  // === ADD TO CART HANDLER ===
  addToCartBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    var purchaseType = document.querySelector('input[name="package_selection"]:checked') ? document.querySelector('input[name="package_selection"]:checked').value : document.querySelector('input[name="purchase_type"]:checked')?.value;
    
    if (!purchaseType) return alert("Please select a purchase type.");

    let selectedRadio;
    if (purchaseType === "subscribe" || purchaseType === "Subs Package") {
      selectedRadio = subscriptionSection.querySelector('input[name="selling_plan"]:checked');
    } else {
      selectedRadio =
        oneTimeSection.querySelector('input[name="one_time_plan"]:checked') ||
        oneTimeSection.querySelector('input[name^="one_time_plan"]:checked');
    }
    if (!selectedRadio) return alert("Please select a plan.");

    var wrapper = selectedRadio.closest(".radioChecSingle");
    var qty = purchaseType === "One Time" ? Number(document.querySelector('.radioChecWrapper.radio-button-design-wrapper input:checked').parentElement.parentElement.dataset.qty) : parseInt(wrapper.getAttribute("data-qty"), 10);
    var sellingPlanId = purchaseType === "subscribe" || purchaseType === "Subs Package" ? selectedRadio.value : null;
    
    
    // if (document.querySelector('[name="package_selection"]:checked').value == 'One Time') {
    //     selectedRadio = subscriptionSection.querySelector('input[name="selling_plan"]:checked');
    //     wrapper = selectedRadio.closest(".radioChecSingle");
    //      qty = parseInt(wrapper.getAttribute("data-qty"), 10);
    //     sellingPlanId = null;
    // }

    const productData = [
      {
        id: parseInt(hiddenVariantInput.value, 10),
        quantity: qty,
        ...(sellingPlanId && { selling_plan: sellingPlanId }),
      },
    ];

    addToCart(productData, addToCartBtn);
  });
});


document.querySelectorAll('[name="package_selection"]').forEach(function(p) {
  p.addEventListener("change", function() {
    var type = this.value;

    if (type === 'One Time') {
      document.querySelector("#subscription-section .radioChecSingle.checked").click();
      document.querySelectorAll("#subscription-section .radioChecSingle").forEach(function(s, index) {
        var price = parseInt(s.getAttribute("data-price"));
        var percent = parseInt(document.querySelectorAll("#one-time-section .radioChecSingle")[index].getAttribute("data-offer"));
        var q = parseInt(document.querySelectorAll("#one-time-section .radioChecSingle")[index].getAttribute("data-qty"));

        console.log(price, percent);

        var last = ((price*(100-percent))/100).toFixed(2);
        s.querySelector(".actual-price").textContent = "$" + last + "/each";
      });
    } else {
      document.querySelector("#subscription-section .radioChecSingle.checked").click();
      document.querySelectorAll("#subscription-section .radioChecSingle").forEach(function(s) {
        var price = s.getAttribute("data-final");
        s.querySelector(".actual-price").textContent = "$" + price + "/each";
      });
    }
  });
});

document.querySelectorAll("#subscription-section .radioChecSingle").forEach(function(s, index){
  s.addEventListener("click", function(){
    setTimeout(() => {
     
    var btn = this;
    var type = document.querySelector('[name="package_selection"]:checked').value;
    
    var compare = parseFloat(btn.getAttribute("data-price"));
    var qty = parseInt(btn.getAttribute("data-qty"));
    var discount = parseInt(document.querySelectorAll("#one-time-section .radioChecSingle")[index].getAttribute("data-offer"));


     var subcompare = parseFloat(btn.getAttribute("data-price"));
    var subqty = parseInt(btn.getAttribute("data-qty"));
    var subdiscount = parseInt(btn.getAttribute("data-offer"));

    var totalCompare = (compare*qty).toFixed();
    var totalPrice = ((compare*qty)*(100-discount)/100.00).toFixed(2);

    var subtotalCompare = (subcompare*subqty).toFixed();
    var subtotalPrice = ((subcompare*subqty)*(100-subdiscount)/100.00).toFixed(2);

    console.log(totalCompare, totalPrice)

    document.querySelector(".oneTimeInner .cut-price").textContent = '$' + totalCompare;
    document.querySelector(".oneTimeInner .offerPrice").textContent = '$' + totalPrice;
    
    if (type === 'One Time') {
      document.querySelector("#add-to-cart-button .regularPriceSubs").textContent = '$' + totalCompare;
      document.querySelector("#add-to-cart-button .btn-final-price").textContent = '$' + totalPrice;
      document.querySelector(".subsPackageInner .regularPriceSubs").textContent = '$' + subtotalCompare;
      document.querySelector(".subsPackageInner .offerPriceSubs").textContent = '$' + subtotalPrice;
    }else{
      var compare = parseFloat(btn.getAttribute("data-price"));
      var qty = parseInt(btn.getAttribute("data-qty"));
      var discount = parseInt(btn.getAttribute("data-offer"));

      var totalCompare = (compare*qty).toFixed();
      var totalPrice = ((compare*qty)*(100-discount)/100.00).toFixed(2);

      document.querySelector("#add-to-cart-button .regularPriceSubs").textContent = '$' + totalCompare;
      document.querySelector("#add-to-cart-button .btn-final-price").textContent = '$' + totalPrice;

      document.querySelector(".subsPackageInner .regularPriceSubs").textContent = '$' + totalCompare;
      document.querySelector(".subsPackageInner .offerPriceSubs").textContent = '$' + totalPrice;
    }
    }, 300);
  })
})

if (document.querySelectorAll("#subscription-section .radioChecSingle").length) {
  let subscriptionSelection = document.querySelectorAll("#subscription-section .radioChecSingle");
 if(subscriptionSelection){
    document.querySelectorAll("#subscription-section .radioChecSingle.checked").click();  
  } 
}